function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#288b94;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "logoListaMen");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "kK5zvg.tif"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M67.86,51.63a1.41,1.41,0,0,1-1.47.79c-1.7,0-3.39,0-5.09,0h-.63c0,.22,0,.4,0,.58v3.66c0,1.08-.37,1.44-1.46,1.44H23.45c-1.24,0-1.56-.32-1.56-1.55V38.2c0-.15,0-.3,0-.44a1.09,1.09,0,0,1,2.16-.1,4,4,0,0,1,0,.6v17.6H58.42V10H24.08v17.6a4,4,0,0,1,0,.6,1.13,1.13,0,0,1-1.13.92,1.11,1.11,0,0,1-1-1,4,4,0,0,1,0-.49V9.16c0-1.08.37-1.44,1.45-1.44h5.78V6.91c0-1.13,0-2.26,0-3.39A1.47,1.47,0,0,1,29.88,2h38ZM31.33,7.72H59.06c1.27,0,1.58.31,1.58,1.59V50.18h5V4.25H31.33Z",
  transform: "translate(-21.89 -2.03)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41.1,36.41H29.72c-1.12,0-1.47-.35-1.47-1.47V16.82c0-1.06.37-1.43,1.4-1.43h23c1,0,1.39.38,1.39,1.38V35c0,1-.38,1.41-1.43,1.41Zm10.75-2.22V17.62H30.47V34.19Z",
  transform: "translate(-21.89 -2.03)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41.17,44.29H29.79a5,5,0,0,1-.55,0,1.09,1.09,0,0,1,0-2.17,4,4,0,0,1,.49,0H52.57a4,4,0,0,1,.49,0,1.09,1.09,0,0,1,0,2.17c-.42,0-.84,0-1.26,0Z",
  transform: "translate(-21.89 -2.03)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M41.16,48.23H52.59a4,4,0,0,1,.6,0,1.09,1.09,0,0,1,0,2.14,3.25,3.25,0,0,1-.54,0H29.71a4,4,0,0,1-.49,0,1.09,1.09,0,0,1,0-2.16,3.33,3.33,0,0,1,.55,0Z",
  transform: "translate(-21.89 -2.03)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M23,34a1.11,1.11,0,0,1-1.09-1.07,1.09,1.09,0,1,1,2.18,0A1.11,1.11,0,0,1,23,34Z",
  transform: "translate(-21.89 -2.03)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39.9,27.1,44,23c.17-.17.33-.34.5-.5a1.09,1.09,0,0,1,1.65-.08,1.11,1.11,0,0,1-.1,1.6c-.66.68-1.34,1.35-2,2l-3.2,3.21a1.14,1.14,0,0,1-1.88,0c-.89-.89-1.78-1.78-2.66-2.68a1.1,1.1,0,0,1-.1-1.64,1.09,1.09,0,0,1,1.64.11C38.52,25.68,39.17,26.36,39.9,27.1Z",
  transform: "translate(-21.89 -2.03)"
}));

var SvgLogoListaMen = function SvgLogoListaMen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 45.97 56.06",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoListaMen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoListaMen.69c5d773.svg";
export { ForwardRef as ReactComponent };